var _class2, _descriptor;
function _initializerDefineProperty(e, i, r, l) { r && Object.defineProperty(e, i, { enumerable: r.enumerable, configurable: r.configurable, writable: r.writable, value: r.initializer ? r.initializer.call(l) : void 0 }); }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _applyDecoratedDescriptor(i, e, r, n, l) { var a = {}; return Object.keys(n).forEach(function (i) { a[i] = n[i]; }), a.enumerable = !!a.enumerable, a.configurable = !!a.configurable, ("value" in a || a.initializer) && (a.writable = !0), a = r.slice().reverse().reduce(function (r, n) { return n(i, e, r) || r; }, a), l && void 0 !== a.initializer && (a.value = a.initializer ? a.initializer.call(l) : void 0, a.initializer = void 0), void 0 === a.initializer ? (Object.defineProperty(i, e, a), null) : a; }
function _initializerWarningHelper(r, e) { throw Error("Decorating class property failed. Please ensure that transform-class-properties is enabled and runs after the decorators transform."); }
import Helper from '@ember/component/helper';
import { inject as service } from '@ember/service';
import listenerName from 'ember-keyboard/utils/listener-name';
import { assert } from '@ember/debug';
let _class = (_class2 = class _class2 extends Helper {
  constructor(...args) {
    super(...args);
    _initializerDefineProperty(this, "keyboard", _descriptor, this);
    _defineProperty(this, "keyCombo", void 0);
    _defineProperty(this, "callback", void 0);
    _defineProperty(this, "keyboardActivated", true);
    _defineProperty(this, "keyboardPriority", 0);
    _defineProperty(this, "eventName", 'keydown');
    _defineProperty(this, "keyboardHandlers", void 0);
  }
  compute([keyCombo, callback], {
    event = 'keydown',
    activated = true,
    priority = 0
  }) {
    assert('ember-keyboard: You must pass a function as the second argument to the `on-key` helper', typeof callback === 'function');
    this.keyCombo = keyCombo;
    this.callback = callback;
    this.eventName = event;
    this.keyboardActivated = activated;
    this.keyboardPriority = priority;
    this.keyboardHandlers = {};
    this.keyboardHandlers[listenerName(event, keyCombo)] = callback;
    this.keyboard.register(this);
  }
  willDestroy() {
    this.keyboard.unregister(this);
    super.willDestroy(...arguments);
  }
}, (_descriptor = _applyDecoratedDescriptor(_class2.prototype, "keyboard", [service], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
})), _class2);
export { _class as default };